var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Auth',[_c('NowLoading',{attrs:{"show":_vm.underLoading}}),_c('div',{staticClass:"sign-in"},[_c('ModuleSignIn')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }